<template>
  <div style="background-color: white; min-height: 100vh">
    <Header />
    <div style="position: relative; color: white; font-family: 'mediumRoboto'">
      <!-- <img src="../../../assets/images/moon_blue_header.jpg" class="eventImg" /> -->
      <v-breadcrumbs
        divider="/"
        :items="breadcrumbs"
        class="breadcrumbs"
      ></v-breadcrumbs>
      <div class="eventRegistration">
        <div class="eventImageWrapper">
          <img class="heroImg" src="../../../assets/images/fishHero.png" />
        </div>
        <div class="participant-counter-wrapper">
          <h2>Starvation Species Sprint</h2>
          <p>Registration & Entry</p>
          <img class="fishRaceImg" src="../../../assets/images/fishRace.svg" />
          <div class="participant-wrapper">
            <div class="participant-counter">
              <v-row justify="start" class="counter-box" no-gutters>
                <v-col cols="auto">
                  <v-btn
                    icon
                    class="counter-button"
                    @click="decreaseAdults"
                    :disabled="adults <= 1"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="auto">
                  <div class="counter-value">{{ adults }}</div>
                </v-col>

                <v-col cols="auto">
                  <v-btn
                    icon
                    class="counter-button"
                    @click="increaseAdults"
                    :disabled="adults >= 90"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <div class="adultMinorText">
                <img src="../../../assets/images/adult.svg" />
                <p>$10 per person</p>
              </div>
            </div>

            <!-- <div class="participant-counter">
              <v-row justify="start" class="counter-box" no-gutters>
                <v-col cols="auto">
                  <v-btn
                    icon
                    class="counter-button"
                    @click="decreaseMinors"
                    :disabled="minors <= 0"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </v-col>

                <v-col cols="auto">
                  <div class="counter-value">{{ minors }}</div>
                </v-col>

                <v-col cols="auto">
                  <v-btn icon class="counter-button" @click="increaseMinors">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <div class="adultMinorText">
                <img src="../../../assets/images/minor.svg" />
                <p>$5 per person</p>
              </div>
            </div> -->
          </div>
          <div class="button-flex">
            <button class="signUpButton" @click="continueToWaiver()">
              Register Now
            </button>
            <p>Limited to 90 individuals</p>
          </div>
        </div>
      </div>

      <div class="page-wrap-overview">
        <div class="overview-section firstSection">
          <div class="overview-text">
            <div class="overview">
              <img src="../../../assets/images/overview-icon.svg" />
              <h1>Overview</h1>
            </div>
            <hr />
            <div class="overview">
              <img src="../../../assets/images/fish-hook.svg" />
              <h2>What</h2>
            </div>
            <p>Incredible fishing challenge</p>
            <div class="overview">
              <img src="../../../assets/images/place-icon.svg" />
              <h2>Place</h2>
            </div>
            <p>Fred Hayes State Park at Starvation</p>
          </div>
          <img
            class="overviewImg"
            src="../../../assets/images/starvation_species_fish.svg"
          />
        </div>
      </div>

      <div class="page-wrap-overview green-wrap">
        <div class="details-section">
          <div class="details-header">
            <div class="overview">
              <img src="../../../assets/images/details.svg" />
              <h1>Details</h1>
            </div>
            <hr />
          </div>
          <div class="details">
            <div class="eventDetails">
              <h2>Overview</h2>
              <p>
                The Starvation Species Sprint is a challenge and an adventure.
                Visit this incredible reservoir to see what fishing
                opportunities it holds. This challenge is all about catching the
                top four most sought after fish in the reservoir. If you can
                catch a Walleye, Smallmouth Bass, Rainbow Trout, and Yellow
                Perch, you will be awarded a unique medallion and certificate of
                completion!
              </p>
            </div>
            <div class="eventDetails">
              <h2>How it works</h2>
              <ol>
                <li>
                  Register for the challenge on this site. Cost is $10 per
                  person.
                </li>
                <li>
                  Go fishing. Catch and photograph at least 1 of each species.
                  There is no time constraint, just write down the date each
                  species was caught.
                </li>
                <li>
                  Fill out a google forum and upload photos here:
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdF_xhaZZpuJRuyJ1R8fm0FZcwiStVjoS1xd5e3G4WhajTR7A/viewform?usp=dialog"
                    >https://docs.google.com/forms/d/e/1FAIpQLSdF_xhaZZpuJRuyJ1R8fm0FZcwiStVjoS1xd5e3G4WhajTR7A/viewform?usp=dialog</a
                  >
                </li>
                <li>
                  Come to the Ranger Office or the Entrance Booth to receive
                  your official certificate and a custom medallion!
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div class="page-wrap-overview">
        <div class="overview-section prizes">
          <div class="overview">
            <img src="../../../assets/images/prizes-icon.svg" />
            <h1>Prizes</h1>
          </div>
          <hr />
          <p>
            Catch all four fish and win a custom medallion and a certificate of
            completion! Photos will be displayed at the Ranger Office!
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://sdks.shopifycdn.com/js-buy-sdk/v2/latest/index.umd.min.js"></script>
<script src="https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js"></script>
<script src="https://evey-files.s3.amazonaws.com/js/evey_buy_button.js"></script>

<script>
import Header from "../../../components/Header.vue";
import $ from "jquery";
export default {
  name: "StarvationSpecies",
  metaInfo: {
    title: "Starvation Species Sprint",
    meta: [
      {
        name: "description",
        content:
          "Purchase your day-use pass for Fred Hayes Starvation Species Sprint Event.",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      breadcrumbs: [],
      variantId: "45464593465497",
      adults: 1,
    };
  },
  created() {
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      {
        text: "Fred Hayes State Park at Starvation",
        disabled: false,
        href: "/parks/" + this.$route.params.name + "/dayuse",
      },
      { text: "Starvation Species Sprint", disabled: true },
    ];
  },
  methods: {
    increaseAdults() {
      this.adults++;
    },
    decreaseAdults() {
      if (this.adults > 1) this.adults--;
    },
    toggleDropdown(key) {
      this.dropdowns[key] = !this.dropdowns[key];
    },
    continueToWaiver() {
      localStorage.setItem("numberOfAdults", this.adults);
      console.log(
        "Number of participants set to local storage: " +
          localStorage.getItem("numberOfAdults") +
          " adults, "
      );
      this.$router.push(
        `/parks/UTFRED/StarvationSpecies/waiver/${this.variantId}`
      );
    },
    getDirections() {
      const url =
        "https://www.google.com/maps/place/37%C2%B007'09.2%22N+113%C2%B022'59.1%22W/@37.1192222,-113.3830833,1203m/data=!3m2!1e3!4b1!4m4!3m3!8m2!3d37.1192222!4d-113.3830833?entry=ttu&g_ep=EgoyMDI1MDYyMy4yIKXMDSoASAFQAw%3D%3D"; // Replace with the actual Google Maps URL
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.eventHeader {
  display: flex;
  padding: 50px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.eventTitle {
  font-size: 64px;
  font-weight: 700;
  margin-bottom: 20px;
  font-family: "boldRoboto";
  line-height: 1.2;
}
.eventSubtitle {
  font-size: 36px;
  font-weight: 400;
  margin: 0;
  font-family: "mediumRoboto";
}
.eventRegistration {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.participant-counter-wrapper {
  display: inline-block;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 50%;
  background-color: #e3e3ce;
  padding: 50px;
  justify-content: center;
  height: 500px;
}
.eventImageWrapper {
  width: 50%;
  background-color: #ddcaa4;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 500px;
}
.participant-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}
.participant-counter-wrapper h2 {
  font-size: 36px;
  font-family: "mediumRoboto";
  margin: 0px;
}
.participant-counter-wrapper p {
  font-size: 24px;
  font-family: "Roboto";
  margin: 0px;
}
.counter-box {
  background-color: #f4f4f4;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
}
.counter-button {
  min-width: 36px;
  height: 36px;
  color: #333;
}
.counter-value {
  width: 32px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 36px;
  color: #333;
}
.signUpButton {
  background: #727a35;
  border: 1px solid #96a145;
  box-sizing: border-box;
  border-radius: 48px;
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 40px;
  font-size: 16px;
  line-height: 1.2;
  display: inline-block;
  font-weight: 1000;
  width: 250px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.signUpButton:hover {
  background-color: #5f6c2c;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.heroImg {
  height: 70%;
}
.fishRaceImg {
  width: 100px;
  padding-bottom: 10px;
}
hr {
  border: 0.5px solid #424242;
  margin: 30px 0;
}
.overview-text hr {
  width: 90%;
}
.details hr {
  border: 0.5px solid #424242;
  width: 100% !important;
  margin: 30px 0;
}
.eventInfo {
  padding: 50px;
  color: #494e53;
}
.eventInfo h1 {
  font-size: 32px;
}
.eventDetails {
  display: flex;
  justify-content: center;
  gap: 30px;
}
.eventDetails div {
  width: 50%;
}
.eventDetails h3 {
  font-family: "boldRoboto";
  font-size: 24px;
  margin-top: 20px;
}
.eventDetails p {
  font-family: "Roboto";
  font-size: 20px;
  margin-top: 10px;
}
.eventDetails li {
  font-family: "Roboto";
  font-size: 20px;
  margin-top: 10px;
}
.details {
  display: flex;
  align-items: flex-start;
  gap: 80px;
  width: 100%;
}
.details div {
  width: 50%;
  display: flex;
  flex-direction: column;
}
ol {
  overflow-wrap: break-word;
  width: 100%;
}
ol a {
  color: #727a35;
  font-size: 20px;
}
.details h2 {
  font-size: 26px;
  font-family: "boldRoboto";
}
.eventDetails .button-flex {
  margin-top: 10px;
}
.button-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.button-flex p {
  font-size: 16px;
  font-family: "Roboto";
  margin-top: 10px;
}
.green-wrap {
  background-color: #e3e3ce !important;
}
.gray-wrap hr {
  border: 0.5px solid white;
  width: 80%;
  margin-bottom: 20px;
}
.gray-wrap h1 {
  color: white;
}
.contact-info {
  display: flex;
  gap: 20px;
  align-items: center;
}
.contact-info a {
  color: white;
  font-size: 16px;
  font-family: roboto;
}
.page-wrap-overview {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #faf9ed;
}
.overview-section {
  display: flex;
  padding: 50px;
  width: 80%;
}
.details-section {
  display: flex;
  padding: 50px;
  width: 80%;
  flex-direction: column;
  align-items: flex-start;
}
.overview {
  display: flex;
  align-items: center;
  gap: 20px;
}
.overview h1 {
  font-size: 48px;
  font-family: "mediumRoboto";
  margin: 0;
}
.overview h2 {
  font-size: 22px;
  font-family: "boldRoboto";
}
.details-header {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.overview-text p {
  margin: 0px 0px 15px 55px;
}
.contact-details {
  display: flex;
  flex-direction: column;
}
.overview-text {
  width: 50%;
}
.overviewImg {
  width: 50%;
}
.prizes {
  display: flex;
  flex-direction: column !important;
}
.prizes p {
  font-size: 20px;
  font-family: "Roboto";
  color: #4a4a4a;
}
.breadcrumbs {
  margin: 22px 32px;
}
.v-breadcrumbs ::v-deep(a) {
  color: #96a145 !important;
}
.participant-counter {
  display: flex;
  align-items: center;
  gap: 10px;
}
.adultMinorText {
  display: flex;
  gap: 10px;
}
@media only screen and (max-width: 1012px) {
  .eventRegistration {
    flex-direction: column;
    align-items: center;
  }
  .heroImg {
    height: auto;
    width: 100%;
    margin: 20px;
  }
  .eventImageWrapper {
    width: 100%;
    height: auto;
  }
  .participant-counter-wrapper {
    width: 100%;
    padding: 50px;
    height: auto;
  }
  .eventDetails {
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
  .eventDetails div {
    width: 100%;
  }
  .contact-info {
    flex-direction: column;
    align-items: flex-start;
  }
  .fishRaceImg {
    width: 30%;
  }
  .participant-counter {
    flex-direction: column;
  }
  .participant-wrapper {
    align-items: center;
  }
  .details {
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
  .details div {
    width: 100%;
    align-items: flex-start;
  }
  .firstSection {
    flex-direction: column;
  }
  .overview-text {
    width: 100%;
  }
  .overviewImg {
    width: 100%;
    margin-top: 30px;
  }
  .eventDetails {
    gap: 10px;
  }
  .overview-section {
    width: 100%;
  }
  .details-section {
    width: 100%;
  }
  .overview-section h1 {
    font-size: 36px;
  }
  .details-section h1 {
    font-size: 36px;
  }
}
</style>
